module.exports = __webpack_public_path__ + "static/media/2021sjz.65085604.jpg";